import { CA_TYPE, setCA } from "@yuanfudao/metis-unified-login"
import { getUniqueId, UNIQUE_ID_TO_CA } from "./project-config/common"

// 这段代码必须在最最顶部
// const query = getUrlQuery()
// if (query.ca) {
//   setCA(query.ca as CA_TYPE)
// } else {
//   const UNIQUE_ID = getUniqueId()
//   const caKeys = Object.keys(CA_TYPE) as CA_TYPE[]
//   let ca = CA_TYPE.FEIXIANG
//   for (const key of caKeys) {
//     if (CA_TYPE[key] === UNIQUE_ID) {
//       ca = UNIQUE_ID
//       break
//     }
//   }
//   setCA(ca)
// }

const UNIQUE_ID = getUniqueId()
const caKeys = Object.keys(CA_TYPE) as CA_TYPE[]
let ca = CA_TYPE.FEIXIANG as any
for (const key of caKeys) {
  if (UNIQUE_ID_TO_CA[UNIQUE_ID] === CA_TYPE[key]) {
    ca = CA_TYPE[key]
    break
  }
}
setCA(ca)
